export class SubCompanyPipelineApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getExpressionDefinitions() {
    return this.#http.get('/api/sub-company-pipelines/expression-definitions');
  }
}
